import React, { useState } from 'react';
import { connect } from 'react-redux';

import * as actions from '../../../redux/actions/etpRegistration';

import style from './purchasingHistory.module.scss';
import SearchImage from '../../../assets/images/Search.svg';
import api from '../../../helpers/api';
import { works } from '../Works';
import { validateInn, validateKpp } from './validation';
import getReferrerFrom from '../../../helpers/lib/getReferrerFrom';

interface IProps {
  setEtpRegistrationSearchResult: Function;
  setETPRegistrationError: Function;
  setETPRegistrationLoading: Function;
}

const RegistrationHistorySearch = ({
  setEtpRegistrationSearchResult,
  setETPRegistrationLoading,
  setETPRegistrationError,
}: IProps) => {
  const [innValue, setInnValue] = useState('');
  const [kppValue, setKppValue] = useState('');
  const [isInnError, setInnError] = useState({ isError: false, errorMessage: '', showError: true });
  const [isKppError, setKppError] = useState({ isError: false, errorMessage: '', showError: true });

  const handleClick = async () => {
    if (works) return;
    if (innValue.trim() === '') {
      setInnError({ isError: true, errorMessage: 'Введите ИНН', showError: true });
      return;
    }
    setInnError({ isError: false, errorMessage: '', showError: false });

    if (!validateInn(innValue)) {
      setInnError({ isError: true, errorMessage: 'Введите корректный ИНН', showError: true });
      return;
    }
    setInnError({ isError: false, errorMessage: '', showError: false });

    if (!validateKpp(kppValue)) {
      setKppError({ isError: true, errorMessage: 'Введите корректный КПП', showError: true });
      return;
    }
    setKppError({ isError: false, errorMessage: '', showError: false });

    try {
      setETPRegistrationError('');
      await setEtpRegistrationSearchResult({});
      await setETPRegistrationLoading(true);
      const res = await api.getEtpRegistration(innValue, kppValue);
      await api.sendReport(api.API_ETP_REPORT_TYPE, {
        ...{ inn: innValue, kpp: kppValue },
        ...getReferrerFrom(),
      });
      if (res.payload[0] === 'NOT_FOUND') {
        setETPRegistrationError(res.payload[0]);
        await setETPRegistrationLoading(false);
        return;
      }
      await setEtpRegistrationSearchResult(res.payload);
      await setETPRegistrationLoading(false);
    } catch (error: any) {
      await setETPRegistrationLoading(false);
      setETPRegistrationError(error.message);
    }
  };

  return (
    <div className={style.searchContainer}>
      <h3 className={style.title}>Введите ИНН или КПП организации</h3>
      <form className={style.form}>
        <div className={style.group}>
          <input
            type="text"
            placeholder="Введите ИНН..."
            className={style.searchInput}
            value={innValue}
            onChange={(event) => setInnValue(event.target.value)}
            onBlur={() => setInnError((prev) => ({ ...prev, showError: false }))}
            onFocus={() => {
              if (innValue.trim() !== '') setInnError((prev) => ({ ...prev, showError: true }));
            }}
          />
          {isInnError.isError && isInnError.showError && <div className={style.error}>{isInnError.errorMessage}</div>}
        </div>

        <div className={style.group}>
          <input
            type="text"
            placeholder="Введите КПП..."
            className={style.searchInput}
            value={kppValue}
            onChange={(event) => setKppValue(event.target.value)}
            onBlur={() => setKppError((prev) => ({ ...prev, showError: false }))}
            onFocus={() => {
              if (kppValue.trim() !== '') setKppError((prev) => ({ ...prev, showError: true }));
            }}
          />
          {isKppError.isError && isKppError.showError && <div className={style.error}>{isKppError.errorMessage}</div>}
        </div>

        <button
          type="submit"
          className={style.searchButton}
          onClick={(event) => {
            event.preventDefault();
            handleClick();
            setTimeout(() => {
              setInnError((prev) => ({ ...prev, showError: false }));
              setKppError((prev) => ({ ...prev, showError: false }));
            }, 5000);
          }}
        >
          <img src={SearchImage} alt="Поиск" className={style.searchImage} />
          Найти
        </button>
      </form>
    </div>
  );
};

export default connect(null, actions)(RegistrationHistorySearch);
